<template>
    <span>
        <base-button size="sm" class="btn btn-icon btn-fab btn-danger btn-sm btn-text" :disabled="disabled"
            @click.native="open">
            <i class="el-icon-close"></i>
        </base-button>

        <modal v-on:close="close" :show.sync="modals.classic" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">{{ currentHeaderText }}</h4>

            <div class="container" v-show="isNoDelete">
                <div>
                    To remove this signature type, you must change the document category in the Documents tab, 
                    or delete the document (Example: Document Type "Transaction Authorization" is updated to "Other").
                </div>

                <div class="row d-flex justify-content-end mt-4">
                    <base-button size="md" variant="warning" @click.native="close">Close</base-button>
                </div>
            </div>

            <div class="container" v-show="!isNoDelete">
                <div>
                    <textarea class="form-control" placeholder="(Provide reason here.)" rows="5"  v-model="input"></textarea>
                </div>

                <div class="row d-flex justify-content-end mt-4">
                    <base-button size="md" variant="warning" @click.native="clear">Clear</base-button>

                    <base-button size="md" variant="primary" @click.native="remove">Submit</base-button>
                </div>
            </div>
        </modal>
    </span>
</template>

<script>
import Utility from "@/mixins/utility/utility";
import { Modal } from "@/components";

import { mapGetters, mapActions } from 'vuex'
export default {
    name: "delete-signature",
    components: {
        Modal,
    },
    mixins: [Utility],
    props: {
        headerText: {
            type: String,
            default: "",
        },
        signatureId: {
            type: Number,
            default: 0,
        },
        signatureType: {
            type: String,
            default: null,
        },
        fileTypeId: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            input: '',
            files: [],

            modals: {
                classic: false,
            },
        }
    },
    computed: {
        ...mapGetters({
            isPartnerAccount: "authentication/isPartnerAccount",
        }),

        getOrderIdFromRoute() {
            return parseInt(this.$route.params.id);
        },
        isNoDelete() {
            return this.signatureType === "UPLOAD" && this.files.length > 0;
        },
        currentHeaderText() {
            return this.isNoDelete ? "REMINDER": this.headerText
        }
    },
    methods: {
        ...mapActions({ deleteSignature: "signature/deleteSignature" }),

        async getFiles() {
            let ctx = this;
            let orderId = ctx.$route.params.id;

            let response = await ctx.axios.get(`api/orderfiles/order/${orderId}/type/${ctx.fileTypeId}`)

            ctx.files = response.data;

        },
        async open() {
            await this.getFiles();

            this.modals.classic = true;
        },

        async remove() {
            try {
                await this.deleteSignature({
                    orderId: this.getOrderIdFromRoute || 0,
                    signatureId: this.signatureId,
                    reason: this.input
                });

                // Success/error toast is shown automatically by axios interceptor
                this.close();
            } catch (error) {
                // Error toast already shown by axios interceptor
                // Still close and reload to clear any unsaved signatures from Vuex
                this.close();
            }
        },

        clear() {
            this.input = "";
        },

        close() {
            this.modals.classic = false;
            this.$emit('modal-closed');
        },
    }
}
</script>

<style scopped>
@import "../../../styles/custom_alert.css";

/* User Profile Modal */
@media (min-width: 576px) {
    .modal.show>.modal-dialog {
        max-width: 800px !important;
        margin: 1.75rem auto;
    }
}
</style>
